/* import __COLOCATED_TEMPLATE__ from './company-profile-notes.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-admin-company-profile-notes';
const NOTE_MAX_LENGTH = 255;

/** @module */
class AdminCompanyProfileNotes extends Component {
  @tracked notes = [];
  @tracked newNoteContent = '';

  constructor() {
    super(...arguments);
    this.loadAdminNotesTask.perform(this.args.company);
  }

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get maxNoteLength() {
    return NOTE_MAX_LENGTH;
  }

  get isSavingNewNote() {
    return this.onSaveAddNewNoteClicked.isRunning;
  }

  @dropTask
  *loadAdminNotesTask(company) {
    this.notes = yield this.args.loadNotesTask.perform(company);
  }

  @dropTask
  *onSaveAddNewNoteClicked(company, noteContent) {
    yield this.args.saveNewNoteTask.perform(company, noteContent);

    // reset new note area
    this.newNoteContent = '';
    this.args.toggleAddNewNote(false);

    // reload notes
    yield this.loadAdminNotesTask.perform(company);
  }

  @dropTask
  *onUpdateNoteClicked(company, note, updatedNoteContent) {
    yield this.args.updateNoteTask.perform(note, updatedNoteContent);

    // reload notes
    yield this.loadAdminNotesTask.perform(company);
  }

  @dropTask
  *onDeleteNoteClicked(company, note) {
    yield this.args.deleteNoteTask.perform(note);

    // reload notes
    yield this.loadAdminNotesTask.perform(company);
  }
}

export default AdminCompanyProfileNotes;
